/*
 * @Description: 
 * @Author: xz
 * @Date: 2023-11-01 08:49:03
 * @LastEditTime: 2023-12-05 11:19:43
 * @LastEditors: xz
 */
import request from '../../utils/request'
export function uploadfbfile(data){
    return request({
        url: "/chachong/uploadfbfile",
        method: "POST",
        data
    })
}
export function getFileList(params){
    return request({
        url: "/log/getFileByaction",
        method: "GET",
        params
    })
}
export function getFile(params){
    return request({
        url: "/log/readFile",
        method: "GET",
        params
    })
}
export function getFileReadData(params){
    return request({
        url: "log/readData",
        method: "GET",
        params
    })
}
// 删除记录
export function deleteFileFp(params){
    return request({
        url: "/log/deleteFileFp",
        method: "GET",
        params
    })
}
//删除文件
export function deleteFile(params){
    return request({
        url: "/log/deleteFile",
        method: "GET",
        params
    })
}
// log/readData?PhoneNum=978299&startTime=2023-10-22%2012:00:00&endTime=2023-10-22%2013:00:00
// https://edam.tscon.cn:7778/ccapi/log/readFile?fileName=浮标轨迹.xls
// https://edam.tscon.cn:7778/ccapi/log/getFileByaction?page=1&size=10&action=pf   获取文件列表


// WEBPACK FOOTER //
// ./src/api/float.js